import { Cookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/auth-context'
import { Helmet } from 'react-helmet-async'

export function Profile() {
  const { user, userLogout } = useAuth()
  const displayName = user?.firstName + ' ' + user?.lastName
  const cookies = new Cookies()
  const navigate = useNavigate()

  const handleLogoutClick = () => {
    cookies.remove('@bookstory-auth-token')
    localStorage.removeItem('shippingForm')
    userLogout()
    navigate('/')
  }

  const handleChangePasswordClick = () => {
    navigate('/change-password')
  }

  const handleEditInformationClick = () => {
    navigate('/update-personal-info')
  }

  const handleAddAddressInfoClick = () => {
    navigate('/add-address-info')
  }
  return (
    <div className='max-w-lg mx-auto flex flex-col my-10 h-auto border py-8 px-4 rounded-md' style={{ backgroundColor: 'var(--card-bg)', color: 'var(--text-primary)', borderColor: 'var(--border-color)' }}>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          تنظیمات
        </title>
        <meta
          name='description'
          content='داستان کتاب - داستان ها همیشه در دل و ذهن می مانند'
        />
      </Helmet>
      <div className='rounded-md divide-y divide-solid divide-gray-100' style={{ backgroundColor: 'var(--accent-primary)' }}>
        <h1 className=' w-full px-4 p-2 text-white text-lg font-bold font-bold'>
          تنظمیات
        </h1>
        <h2 className='w-full p-2 my-4 text-white text-lg font-bold font-bold'>
          حساب کاربری {displayName}
        </h2>
      </div>
      <button
        className='w-full rounded text-white uppercase border-none mt-10 p-4 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        style={{ backgroundColor: 'var(--accent-primary)' }}
        type='submit'
        onClick={handleChangePasswordClick}
      >
        تغییر رمز کاربری
      </button>
      <button
        className='w-full rounded text-white uppercase border-none mt-10 p-4 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        style={{ backgroundColor: 'var(--accent-primary)' }}
        type='submit'
        onClick={handleEditInformationClick}
      >
        ویرایش اطلاعات شخصی
      </button>
      {/* <button
         className='bg-[#5E81AC] w-full rounded text-white uppercase border-none mt-10 p-4 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        type='submit'
        onClick={handleAddBankAccountInfoClick}
      >
        Add Bank Account Information
      </button> */}
      <button
        className='w-full rounded text-white uppercase border-none mt-10 p-4 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        style={{ backgroundColor: 'var(--accent-primary)' }}
        type='submit'
        onClick={handleAddAddressInfoClick}
      >
        اضافه کردن اطلاعات آدرس
      </button>
      <button
        className='w-full rounded text-white uppercase border-none mt-10 p-4 text-xl font-medium active:transition-all active:duration-[0.3s] active:opacity-80 cursor-pointer'
        style={{ backgroundColor: 'var(--accent-primary)' }}
        type='submit'
        onClick={handleLogoutClick}
      >
        خروج از حساب کاربری
      </button>
    </div>
  )
}
